import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ListItem} from "../../../objects/listItem";
import {ListingModel} from "../../../objects/listing-model";
import {SubscriptionLike} from "rxjs";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AppComponent} from "../../../app.component";
import {MobileContainerComponent} from "../mobile-container/mobile-container.component";
import {SharedDataService} from "../../../services/shared-data.service";
import {ActivatedRoute} from "@angular/router";
import {AppEvent} from "../../../objects/appEvent";
import {environment} from "../../../../environments/environment";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";

@Component({
  selector: 'app-simple-list',
  templateUrl: './simple-list.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class SimpleListComponent implements OnInit {
  @Input()
  stateToPick: string
  @Input()
  payload: object

  state: string = 'loading';
  errMsg: string = '';
  activeItem: ListItem; // Element on which was called context menu
  listing: ListingModel;
  typicalItemHeight; //94 squash_default,
  private sharedEventSubscription: SubscriptionLike;

  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;

  constructor(public application: AppComponent,
              public dialog: MatDialog,
              public mobileContainer: MobileContainerComponent,
              public sharedDataService: SharedDataService,
              public route: ActivatedRoute) { }

  ngOnInit(): void {
    if(this.stateToPick) {
      this.listing = new ListingModel();
      this.listing.listItems = this.payload['players'];
      this.state = this.stateToPick;
    } else { //if not set explicitly - pick default from ancestor state
      this.stateToPick = this.mobileContainer.state;
      this.loadItems();
    }
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.MOBILE_STATE_CHANGE && this.application.user?.id &&
          ['trainers','trainers_widget'].includes(appEvent.data['newState'])) {
          this.stateToPick = appEvent.data['newState'];
          this.loadItems();
        }
        // if (appEvent.type === AppEvent.USER_HAS_BEEN_LOGGED && this.application.user?.id) { //deprecated
        //   this.loadItems();
        // }
      });
  }
  ngOnDestroy(): void {
    this.sharedEventSubscription.unsubscribe();
  }

  private loadItems() {
    this.state = 'loading';
    this.listing = new ListingModel();
    if(['trainers','trainers_widget'].includes(this.stateToPick)) {
      this.application.apiService.getGroupTrainers()
        .subscribe(
          data => this.handleItems(data),
          error => this.handleItemsError(error))
    // } else if(['cup_players_view'].includes(this.stateToPick)) {
      // this.application.apiService.getCupDetails(environment['gid'],environment['g_hash'],this.payload['cupID'])
      //   .subscribe(
      //     data => this.handleItems(data),
      //     error => this.handleItemsError(error))
    }
  }
  private handleItems(items) {
    this.state = this.stateToPick;
    this.listing.listItems = items;
    this.listing.sortItems('id_desc');
    this.activeItem = this.listing.listItems[0];
    switch (this.stateToPick) {
      case 'trainers':
      case 'trainers_widget':
        this.typicalItemHeight = 80;
        setTimeout(() => {
          // better to set viewport size explicitly vs some extra bottom offset
          this.viewport.setTotalContentSize(this.typicalItemHeight * (this.listing.listItems.length + 0.2))
        });
        break;
    }
  }
  private handleItemsError(error) {
    this.state = 'error';
    this.errMsg = error.errMsg;
  }

  private clickOnItem(event, targetItem: ListItem) {
    this.activeItem = targetItem;
    switch (this.stateToPick) {
      case 'trainers':
        //this.application.router.navigateByUrl('/squash/trainerview_booking/'+targetItem.itemFullData['id'])
        this.application.router.navigateByUrl('/squash/trainerview/'+targetItem.itemFullData['id'])
        break;
      case 'trainers_widget':
        this.showTrainerPopup();
        break;
    }
  }

  private showTrainerPopup() {
    const commonDialogConf = {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
    }
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'trainer-info-popup',
        payload: {item: this.activeItem},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
  }
}
